export enum CoordsMessages {
  readCoordsSuccess = "coords.readCoordsSuccess",
  noCoordFound = "coords.noCoordFound",
  readCoordsError = "coords.readCoordsError"
}

export type TranslationCoordsMessages = {
  [key in CoordsMessages]: string;
}
